import { Link } from "react-router-dom";
import { BellRing, FileText, Send } from "lucide-react";
import { defineModuleUi, useOrg } from "@vixio/data";
import { formatInt, lazyPage } from "@vixio/ui";
import "./api";
import { useQueueHealth } from "./widget-data";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const QueuePage = lazyPage(() => import("./QueuePage"), "QueuePage");
const TemplatesPage = lazyPage(() => import("./TemplatesPage"), "TemplatesPage");
const ProvidersPage = lazyPage(() => import("./ProvidersPage"), "ProvidersPage");
const OptOutPage = lazyPage(() => import("./OptOutPage"), "OptOutPage");

function QueueWidget() {
  const org = useOrg();
  const h = useQueueHealth(org.id).data;
  return (
    <dl className="vx-dl">
      <dt>Na fila</dt>
      <dd className="num">{formatInt(h?.queued ?? 0)}</dd>
      <dt>Enviados em 7 dias</dt>
      <dd className="num">{formatInt(h?.sent_7d ?? 0)}</dd>
      <dt>Com erro</dt>
      <dd className={(h?.dead ?? 0) > 0 ? "num text-crit" : "num"}>{formatInt(h?.dead ?? 0)}</dd>
      <dt />
      <dd><Link to={(h?.dead ?? 0) > 0 ? "/configuracoes/avisos?aba=erros" : "/configuracoes/avisos"}>Abrir avisos</Link></dd>
    </dl>
  );
}

export default defineModuleUi({
  key: "notifications",
  title: "Avisos",
  domain: "platform",
  icon: BellRing,
  menu: [
    { path: "/configuracoes/avisos", label: "Avisos", minRole: "member", icon: BellRing, order: 30, end: true, keywords: "notificações fila e-mail whatsapp sms erros supressão opt-out" },
    { path: "/configuracoes/avisos/modelos", label: "Modelos de aviso", minRole: "member", icon: FileText, order: 31, keywords: "template mensagem texto versão prévia" },
    { path: "/configuracoes/avisos/provedores", label: "Provedores de aviso", minRole: "member", icon: Send, order: 32, keywords: "smtp whatsapp sms push webhook janela de silêncio" },
  ],
  routes: [
    { path: "/configuracoes/avisos", element: <QueuePage />, minRole: "member" },
    { path: "/configuracoes/avisos/modelos", element: <TemplatesPage />, minRole: "member" },
    { path: "/configuracoes/avisos/provedores", element: <ProvidersPage />, minRole: "member" },
  ],
  widgets: [{ key: "notifications.queue", title: "Avisos", minRole: "manager", span: 1, order: 90, element: QueueWidget }],
  publicRoutes: [{ path: "/avisos/sair/:id", element: <OptOutPage /> }],
});
